import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DetailedRegion } from 'src/app/shared/models/dtos/region/detailed-region';

@Component({
  selector: 'app-region-target-form',
  templateUrl: './region-target-form.component.html',
  styleUrls: ['./region-target-form.component.scss'],
})
/**
 * Component for displaying region target form
 */
export class RegionTargetFormComponent {
  @Input() formGroup!: FormGroup;
  @Input() regionList: DetailedRegion[] = [];
}
